import React from 'react';
import { MessageCircle } from 'lucide-react';
import { businessInfo } from '../mockData';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const phone = businessInfo.phones[0].replace(/\s+/g, '').replace('+', '');
    const message = encodeURIComponent('Hi, I am interested in your interior design services.');
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-1 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Chat with us
      </span>
    </button>
  );
};

export default WhatsAppButton;
